import React from "react";

const ModalWrapper = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center ">
      <div
        className="absolute inset-0 backdrop-blur-sm backdrop-brightness-75"
        onClick={onClose}
      ></div>

      <div className="relative z-10 max-h-[90vh] w-[70%] max-w-3xl overflow-y-auto rounded-2xl bg-white shadow-lg">
        <button
          onClick={onClose}
          className="absolute right-4 top-4 rounded-full p-2 text-xl text-[#c51369] hover:bg-gray-200 focus:outline-none "
        >
          ✕
        </button>
        {children}
      </div>
    </div>
  );
};

export default ModalWrapper;

// import React, { useEffect } from "react";

// const ModalWrapper = ({ isOpen, onClose, children }) => {
//   // Prevent body scroll when modal is open
//   useEffect(() => {
//     if (isOpen) {
//       document.body.style.overflow = "hidden";
//     } else {
//       document.body.style.overflow = "";
//     }
//     return () => {
//       document.body.style.overflow = "";
//     };
//   }, [isOpen]);

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 z-50 flex items-end justify-center sm:items-center sm:px-4">
//       {/* Backdrop */}
//       <div
//         className="absolute inset-0 backdrop-blur-sm backdrop-brightness-75"
//         onClick={onClose}
//       />

//       {/* Modal panel */}
//       <div className="relative z-10 w-full sm:max-w-lg md:max-w-xl lg:max-w-2xl">
//         {/* Close button */}
//         <button
//           onClick={onClose}
//           aria-label="Close modal"
//           className="absolute right-3 top-3 z-20 flex h-8 w-8 items-center justify-center rounded-full bg-white/20 text-sm text-white transition hover:bg-white/30 focus:outline-none sm:right-4 sm:top-4 sm:h-9 sm:w-9 sm:text-base"
//         >
//           ✕
//         </button>

//         {children}
//       </div>
//     </div>
//   );
// };

// export default ModalWrapper;
